import { createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import { FETCH_LOGS, SET_LOGS } from './types';

const INITIAL_STATE = Immutable({
  loading: false,
  logs: [],
});

const setLoading = (state) => state.merge({
  ...state,
  loading: true,
});

const setLogs = (state, { payload }) => state.merge({
  ...state,
  logs: payload.map((item) => ({
    ...item,
    key: item.id,
  })),
  loading: false,
});

const reducers = createReducer(INITIAL_STATE, {
  [FETCH_LOGS]: setLoading,
  [SET_LOGS]: setLogs,
});

export default reducers;
